import { render, staticRenderFns } from "./SendReminderModal.vue?vue&type=template&id=6f035547&"
import script from "./SendReminderModal.vue?vue&type=script&lang=js&"
export * from "./SendReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f035547')) {
      api.createRecord('6f035547', component.options)
    } else {
      api.reload('6f035547', component.options)
    }
    module.hot.accept("./SendReminderModal.vue?vue&type=template&id=6f035547&", function () {
      api.rerender('6f035547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/FinalDocuments/SendReminderModal.vue"
export default component.exports